var $783625afffe8d008$exports = {};
$783625afffe8d008$exports = {
    "info": `Informa\xe7\xf5es`,
    "negative": `Erro`,
    "positive": `Sucesso`
};


export {$783625afffe8d008$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
